module.exports = __webpack_public_path__ + "img/linkedin.e461c993.svg";